import {
  ReactNode,
  createContext,
  memo,
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { cva } from "class-variance-authority";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import _ from "lodash";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import {
  ListFieldsRecordType,
  ListFieldsType,
  emailsSender,
  siteUrl,
} from "src/api/config";
import {
  checkListOWDIdsListName,
  checkListsOWDListName,
  getNotificationsListName,
  notificationTestResult,
  notificationsListName,
  templateOWDQuestionsListName,
  templatesOWDListName,
} from "src/api/config/notifications.config";
import { DrawerComponent, Modal } from "src/components/DialogComponent";
import { EmptyList } from "src/components/EmptyList";
import Loading from "src/components/Loading";
import { NotificationBigIcon } from "src/components/ui-icons/sidebar/NotificationIcon";
import CommentIcon from "src/components/ui-icons/table/CommentIcon";
import {
  ApproveIcon,
  EyeIcon,
  StarIcon,
} from "src/components/ui-icons/table/notificationStatus";
import SortIcon from "src/components/ui-icons/table/SortIcon";
import RejectedPassingTest from "src/components/ui-icons/tests/RejectedPassingTest";
import SuccessfullyPassingTest from "src/components/ui-icons/tests/SuccessfullyPassingTest";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import { Card } from "src/components/ui/Card";
import { searchPeopleRequest } from "src/components/ui/form/peoplePicker/api";
import { SearchUI } from "src/components/ui/Search";
import Pagination from "src/components/ui/table/Pagination";
import { TableHeaderColumnProps } from "src/components/ui/table/Table";
import TGButton from "src/components/ui/TGButton";
import TGCheckbox from "src/components/ui/TGCheckbox";
import TGRadio from "src/components/ui/TGRadio";
import TGTag from "src/components/ui/TGTag";
import { UserAvatarItem } from "src/components/ui/TGUserAvatarsList";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { useGetSelect } from "src/hooks/redux-selectors";
import useAsyncEffect from "src/hooks/useAsyncEffect";
import { usePagination } from "src/hooks/usePagination";
import { getNotificationsInfo } from "src/modules/acadia/notifications/actions";
import { getTransformDataByActiveNotify } from "src/modules/acadia/notifications/sagas/notificationsInfoWatcher";
import { LookupFields } from "src/modules/modules.type";
import { getItems, updateItem } from "src/modules/spItems/actions";
import {
  addItemRequest,
  deleteItemRequest,
  getItemsRequest,
  updateItemRequest,
} from "src/modules/spItems/api";
import {
  selectGetStatus,
  selectItems,
  selectJustUpdatedItem,
} from "src/modules/spItems/selectors";
import { getUserProperties } from "src/modules/users/api";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import PassingTestMobile from "src/pages/DashboardPage/acadia/components/PassingTest/PassingTest.mobile";
import { PassingTestContext } from "src/pages/DashboardPage/acadia/components/PassingTest/passingTestContext";
import { TEST_STATUSES } from "src/pages/DashboardPage/acadia/components/Tests/types";
import { TableColumnWithIcon } from "src/pages/DashboardPage/acadia/mock";
import { useStatusContext } from "src/pages/DashboardPage/acadia/notificationPage";
import { MyListbox } from "src/pages/DashboardPage/acadia/notificationPage/SelectEmployees";
import { SelectIcon } from "src/pages/DashboardPage/acadia/notificationPage/SelectIcon";
import SelectReviewDateMobile from "src/pages/DashboardPage/acadia/notificationPage/SelectReviewDate.mobile";
import AddActionInComponent from "src/pages/DashboardPage/mytasks/addAction/inComponent";
import { PersonType } from "src/pages/DashboardPage/mytasks/meetingsPage/type";
import { LookUpRecord, SearchPeopleType, UserRecord } from "src/types/main";
import { emailAPI, getUrlWithoutAttr } from "src/utils/api.utils";
import { TooltipItem } from "src/utils/Tooltip";
import {
  getNameAndSurname,
  nameFromEmail,
  prefix,
  removePrefix,
} from "src/utils/users.utils";
import { useGetPassingTest } from "../../../pages/DashboardPage/acadia/components/PassingTest/UseGetPassingTest";
import { emailQueueListName } from "./../../../api/config/email.config";
import { shortNameFromEmail } from "./../../../utils/users.utils";
import { chunkArray } from "src/utils/array.utils";
import { DownloadPDFButton } from "src/components/OWDCheckListDownloadPDF";
import { mode, autoCloseModal } from "src/constants";
import { notificationStatuses } from "src/api/config/systemSwitch";
import { isMobile } from "src/utils/device";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import rehypeRaw from "rehype-raw";

const { sendEmail, createEmailBodyByTemplate, deleteEmail } = emailAPI();

type TableHeadType =
  | "NotificationType"
  | "Document"
  | "SendDate"
  | "Author"
  | "ReviewDate";

export type TableBodyGetNotificationItem = {
  ID: number;
  NotificationID: number;
  NotificationType: LookUpRecord;
  Test: number | null;
  Document: {
    Code: string;
    Name: string;
    ID: number;
  };
  SendDate: string;
  Author: { User: UserRecord; Comment: string };
  ReviewDate: { date: string; expired: boolean };
  VersionDocument: LookupFields;
  Completed: Date | string;
  Employee: UserRecord;
  TestedEmployee: string | null;
  CheckListID: number | null;
  TemplateID: number;
};

const tableHeaderContent: Record<TableHeadType, TableColumnWithIcon> = {
  NotificationType: {
    title: "Тип уведомления",
    sort: true,
    style: { width: "20%" },
  },
  Document: {
    title: "Документ",
    sort: true,
    style: { width: "30%" },
  },
  SendDate: {
    title: "Отправлено",
    sort: true,
    style: { width: "10%" },
  },
  Author: {
    title: "Отправитель",
    sort: false,
    style: { width: "25%" },
  },
  ReviewDate: {
    title: "Срок рассмотрения",
    sort: true,
    style: { width: "15%" },
  },
};

function GetNotificationTable() {
  const getNotifications = useAppSelector(
    (state) => state.spitems.elements.obj.GetNotifications,
  ) as unknown as Record<number, TableBodyGetNotificationItem>;

  const updateNotification = useAppSelector((state) =>
    selectJustUpdatedItem(state, notificationsListName),
  ) as unknown as LookUpRecord;

  const [items, setItems] = useState<TableBodyGetNotificationItem[]>([]);
  const [sortedField, setSortedField] = useState<
    keyof TableBodyGetNotificationItem | null
  >("SendDate");
  const [sortDirection, setSortDirection] = useState<
    "asc" | "desc" | "default"
  >("asc");

  const handleSort = (field: keyof TableBodyGetNotificationItem) => {
    if (sortedField === field) {
      setSortDirection((prevDirection) =>
        prevDirection === "asc"
          ? "desc"
          : prevDirection === "desc"
            ? "default"
            : "asc",
      );
    } else {
      setSortedField(field);
      setSortDirection("asc");
    }
  };

  const sortedTableBodyContent = useMemo(() => {
    if (!sortedField || sortDirection === "default") {
      return items;
    }

    const sortedData = [...items];

    sortedData.sort((a, b) => {
      if (sortedField === "NotificationType") {
        return sortDirection === "asc"
          ? a[sortedField].Title.localeCompare(b[sortedField].Title)
          : b[sortedField].Title.localeCompare(a[sortedField].Title);
      }

      if (sortedField === "Document") {
        return sortDirection === "asc"
          ? a[sortedField].Name.localeCompare(b[sortedField].Name)
          : b[sortedField].Name.localeCompare(a[sortedField].Name);
      }

      if (sortedField === "ReviewDate") {
        const dateA = moment(a[sortedField]?.date, "DD.MM.YYYY");
        const dateB = moment(b[sortedField]?.date, "DD.MM.YYYY");

        if (!dateA.isValid() || !dateB.isValid()) {
          console.error("Неверная дата", a[sortedField], b[sortedField]);
          return 0;
        }

        return sortDirection === "asc"
          ? dateA.diff(dateB) // если dateA после dateB вернется положительное число
          : dateB.diff(dateA); // для обратного порядка сортировки
      }

      if (sortedField === "SendDate") {
        return sortDirection === "asc"
          ? moment(a[sortedField]).diff(moment(b[sortedField]))
          : moment(b[sortedField]).diff(moment(a[sortedField]));
      }

      const valueA = a[sortedField];
      const valueB = b[sortedField];

      if (typeof valueA === "string" && typeof valueB === "string") {
        return sortDirection === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      } else if (typeof valueA === "boolean" && typeof valueB === "boolean") {
        return sortDirection === "asc"
          ? Number(valueA) - Number(valueB)
          : Number(valueB) - Number(valueA);
      }

      return 0;
    });

    return sortedData;
  }, [sortedField, sortDirection, items]) as TableBodyGetNotificationItem[];

  const [page, setPage] = useState(1);
  const limit = 10;

  const {
    numberOfPages,
    pageItems,
    length: favoriteItemsCount,
  } = usePagination(sortedTableBodyContent, limit, page);

  function changePageHandler(page: number) {
    setPage(page);
  }

  useLayoutEffect(() => {
    if (getNotifications) {
      if (Object.values(getNotifications).length > 0) {
        const itemsData = getTransformDataByActiveNotify(
          Object.values(getNotifications) as any,
        );

        setItems(itemsData);
      } else {
        setItems([]);
      }
    }
  }, [updateNotification, getNotifications]);

  return (
    <Table
      tableName="Table with get notifications"
      count={favoriteItemsCount}
      numberOfPages={numberOfPages}
      header={tableHeaderContent}
      body={pageItems}
      page={page}
      limit={limit}
      onChangePage={changePageHandler}
      handleSort={handleSort}
      sortDirection={sortDirection}
      sortedField={sortedField}
    />
  );
}

export default GetNotificationTable;

function Table({
  header,
  body,
  page,
  limit,
  count,
  numberOfPages,
  onChangePage,
  tableName,
  handleSort,
  sortedField,
  sortDirection,
}: {
  header: typeof tableHeaderContent;
  body: TableBodyGetNotificationItem[];
  limit: number;
  count: number;
  page: number;
  numberOfPages: number;
  onChangePage: (page: number) => void;
  tableName: string;
  handleSort: (f: keyof TableBodyGetNotificationItem) => void;
  sortedField: keyof TableBodyGetNotificationItem | null;
  sortDirection: "asc" | "desc" | "default";
}) {
  return (
    <FlexRow>
      <FlexCol className="w-full">
        <TableList
          head={header}
          body={body}
          sort={handleSort}
          sortDirection={sortDirection}
          sortedField={sortedField}
          tableName={tableName}
        />
        {count > limit && (
          <Pagination
            numberOfPages={numberOfPages}
            page={page}
            onChange={onChangePage}
          />
        )}
      </FlexCol>
    </FlexRow>
  );
}

function TableList({
  head,
  body,
  sort,
  sortDirection,
  sortedField,
}: {
  head: Omit<typeof tableHeaderContent, "ID">;
  body: TableBodyGetNotificationItem[];
  sort: (f: keyof TableBodyGetNotificationItem) => void;
  sortedField: keyof TableBodyGetNotificationItem | null;
  sortDirection: "asc" | "desc" | "default";
  tableName: string;
}) {
  const [query, setQuery] = useSearchParams();

  const getNotificationsStatus = useAppSelector((state) =>
    selectGetStatus(state, getNotificationsListName),
  );

  function handleClickNotificationCard(item: TableBodyGetNotificationItem) {
    const newSearchParams = new URLSearchParams(query);

    if (
      item.NotificationType.ID === notificationStatuses.approval ||
      item.NotificationType.ID === notificationStatuses.cancel ||
      item.NotificationType.ID === notificationStatuses.approved ||
      item.NotificationType.ID === notificationStatuses.revision
    ) {
      newSearchParams.set("notificationID", item.ID.toString());

      if (!!item.VersionDocument) {
        let versionID = item.VersionDocument.get_lookupId();

        newSearchParams.set("version", versionID.toString());
      }

      newSearchParams.set("documentCardMobile", item.Document.ID.toString());
    } else {
      newSearchParams.set("notificationCard", item.ID.toString());
    }

    setQuery(newSearchParams);
  }

  return (
    <FlexRow className="px-6 py-5 overflow-x-auto bg-white rounded-lg table-custom shadow-custom scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-thumb-[#D1D5DB]">
      <FlexCol className="divide-y min-w-[1252px] grow">
        <FlexRow className="gap-x-4 pb-5">
          {Object.keys(head).map((fieldKey) => {
            const key = fieldKey as TableHeadType;

            return (
              <TableHeaderColumn
                key={fieldKey}
                tableHeaderContent={head[key]}
                sortDirection={sortedField === key ? sortDirection : "default"}
                onClick={() => sort(key)}
              />
            );
          })}
        </FlexRow>
        {getNotificationsStatus !== "SUCCESS" ? (
          <div className="pt-4">
            <Loading />
          </div>
        ) : Array.isArray(body) && body.length > 0 ? (
          body.map((item) => (
            <ListItem
              key={item.ID}
              item={item}
              openItem={handleClickNotificationCard}
            />
          ))
        ) : (
          <EmptyList
            icon={<NotificationBigIcon />}
            title="У вас нет новых уведомлений"
          />
        )}
      </FlexCol>
      {query.has("notificationCard") && (
        <GetNotificationDrawer listName={getNotificationsListName} />
      )}
    </FlexRow>
  );
}

type NotificationDrawerProps = {
  listName: typeof getNotificationsListName | typeof notificationsListName;
  read?: boolean;
  zIndex?: number;
};

export const GetNotificationDrawer = memo((props: NotificationDrawerProps) => {
  let { listName, read = false, zIndex } = props;
  const [query, setQuery] = useSearchParams();
  const [openNotificationCard, setOpenNotificationCard] = useState(read);
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState<TableBodyGetNotificationItem>();

  const currentUser = useAppSelector(selectCurrentUser);

  useEffect(() => {
    if (!openNotificationCard) return;

    // Headless UI держит фокус на пустом initialFocus-«якоре» диалога. Его FocusTrap
    // возвращает фокус обратно на якорь (focusElement(blurTarget)), если фокус ушёл на поле
    // внутри вложенной модалки («Дата проведения OWD», «Кому проводят OWD»), — из-за этого
    // клик по полю не ставит курсор. Снимаем фокус с чужого якоря до того, как браузер
    // переведёт его на поле: blur() без relatedTarget FocusTrap не обрабатывает.
    const releaseFocusAnchor = (e: Event) => {
      const active = document.activeElement as HTMLElement | null;
      if (!active || active === document.body) return;
      const target = e.target as HTMLElement | null;
      if (target && active.contains(target)) return;
      const isFocusAnchor =
        active.tagName === "DIV" && active.tabIndex === -1 && !active.className;
      if (isFocusAnchor) {
        active.blur();
      }
    };
    document.addEventListener("pointerdown", releaseFocusAnchor, true);
    document.addEventListener("mousedown", releaseFocusAnchor, true);

    const portalRoot = document.getElementById("headlessui-portal-root");

    const healPortals = () => {
      if (!portalRoot) return;

      const portals = Array.from(
        portalRoot.querySelectorAll('[data-headlessui-portal]'),
      ) as HTMLElement[];

      portals.forEach((portal) => {
        const containsDialog = !!portal.querySelector('[role="dialog"]');
        if (!containsDialog) return;

        if (portal.getAttribute("aria-hidden") === "true") {
          portal.setAttribute("aria-hidden", "false");
        }
        if (portal.hasAttribute("inert")) {
          portal.removeAttribute("inert");
        }
      });
    };

    healPortals();

    let observer: MutationObserver | undefined;

    if (portalRoot) {
      observer = new MutationObserver(() => {
        healPortals();
      });

      observer.observe(portalRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["aria-hidden", "inert", "data-headlessui-portal"],
      });
    }

    return () => {
      document.removeEventListener("pointerdown", releaseFocusAnchor, true);
      document.removeEventListener("mousedown", releaseFocusAnchor, true);
      observer?.disconnect();
    };
  }, [openNotificationCard]);

  // Мемоизированная функция для управления состоянием Drawer
  const toggleDrawer = useCallback(
    (state: boolean) => {
      if (!state) {
        const newQuery = new URLSearchParams(query.toString());
        newQuery.delete("notificationCard");
        setQuery(newQuery);
      }
      setOpenNotificationCard(state);
    },
    [query, setQuery],
  );

  // Хук для отслеживания изменений в query и загрузки данных
  useAsyncEffect(async () => {
    if (query.has("notificationCard") && currentUser.accountName) {
      const id = query.get("notificationCard");
      try {
        setLoading(true);
        const { items } = await getItemsRequest({
          listName: notificationsListName,
          filters: { ID: [id] },
        });

        const notificationCardItem = items[0];

        const userEmail = removePrefix(currentUser.accountName, prefix);

        const isHasAccess =
          read || notificationCardItem.EmployeeEmail === userEmail;

        if (!isHasAccess) {
          toggleDrawer(false);
        }

        if (notificationCardItem) {
          setOpenNotificationCard(true);

          const [itemModifiedData] = getTransformDataByActiveNotify([
            notificationCardItem,
          ]);
          setItem(itemModifiedData);
        } else {
          toggleDrawer(false);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    } else {
      setOpenNotificationCard(false);
    }
  }, [
    query.get("notificationCard"),
    toggleDrawer,
    currentUser.accountName,
    currentUser.isAdmin,
  ]); // Добавляем `toString()` для избегания перерендеров

  // Обрабатываем случай, когда item не загружен
  if (!item) {
    return null;
  }

  return (
    <DrawerComponent
      open={openNotificationCard}
      toggleDrawer={toggleDrawer}
      zIndex={zIndex}
    >
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <Loading />
        </div>
      ) : (
        openNotificationCard &&
        item && (
          <DrawerContent
            zIndex={zIndex}
            read={read}
            item={item as any}
            toggleDrawer={toggleDrawer}
          />
        )
      )}
    </DrawerComponent>
  );
});

function ListItem({
  item,
  openItem,
}: {
  item: TableBodyGetNotificationItem;
  openItem: (item: TableBodyGetNotificationItem) => void;
}) {
  return (
    <FlexRow
      className="py-4  hover:bg-[#F3F4F6] hover:bg-opacity-50 rounded-lg  cursor-pointer gap-x-4 -mx-2 px-2"
      key={item.ID}
      onClick={() => openItem(item)}
    >
      <FlexCol
        className="break-words text-[#637381] justify-center"
        style={{ width: "20%" }}
      >
        <FlexRow className="gap-x-2.5 items-center">
          <FlexCol>
            {item.NotificationType.ID === 1 ||
            item.NotificationType.ID === 4 ||
            item.NotificationType.ID === 5 ? (
              <EyeIcon />
            ) : (
              ""
            )}
            {item.NotificationType.ID === 3 ? <ApproveIcon /> : ""}
            {item.NotificationType.ID === 2 ||
            item.NotificationType.ID === 6 ? (
              <StarIcon />
            ) : (
              ""
            )}
          </FlexCol>
          <FlexCol>{item.NotificationType.Title}</FlexCol>
        </FlexRow>
      </FlexCol>
      <FlexCol className="break-words text-darkblue" style={{ width: "30%" }}>
        <FlexRow>{item.Document.Code}</FlexRow>
        <FlexRow className="text-darkblue">{item.Document.Name}</FlexRow>
      </FlexCol>
      <FlexCol className="break-words text-[#637381]" style={{ width: "10%" }}>
        {item.SendDate}
      </FlexCol>
      <FlexCol className="break-words text-[#637381]" style={{ width: "25%" }}>
        <FlexRow className="gap-x-[5px] items-center">
          <FlexCol className="break-words shrink-0">
            <UserAvatarItem
              item={{
                name: item.Author.User.Name,
                shortName: shortNameFromEmail(item.Author.User.Email),
                email: item.Author.User.Email,
                id: item.Author.User.ID,
              }}
              single={true}
            />
          </FlexCol>
          <FlexCol className="w-3/12">
            <FlexRow className="space-x-2.5">
              {!!item.Author.Comment && (
                <FlexCol>
                  <TooltipItem
                    tooltipsText={item.Author.Comment}
                    position="top"
                    className="w-72 group"
                    hoverClassName="hover-black-svg"
                    textClassName="whitespace-wrap text-center text-black"
                  >
                    <CommentIcon />
                  </TooltipItem>
                </FlexCol>
              )}
            </FlexRow>
          </FlexCol>
        </FlexRow>
      </FlexCol>
      <FlexCol
        className={twMerge(
          "break-words",
          item.ReviewDate.expired ? "text-red" : "",
        )}
        style={{ width: "15%" }}
      >
        {item.ReviewDate.date}
      </FlexCol>
    </FlexRow>
  );
}

interface TemplateContextType {
  percentOneQuestion: number;
  totalPercentage: number;
  totalAnswersObject: Record<any, any>;
  totalQuestions: number;
  changeTotalPercentage: (v: number) => void;
  changeTotalQuestions: (v: number) => void;
  changeTotalAnswersObject: (key: string, v: any) => void;
  resetTotalPercentage: () => void;
  read: boolean;
}

const TemplateContext = createContext<TemplateContextType | null>(null);

export const useTemplateContext = (): TemplateContextType => {
  const context = useContext(TemplateContext);

  if (!context) {
    throw new Error(
      "useTemplateContext должен использоваться внутри TemplateProvider",
    );
  }

  return context;
};

interface TemplateProviderProps {
  initialAnswers: Record<any, any>;
  read?: boolean;
  children: ReactNode;
}

export const TemplateProvider: React.FC<TemplateProviderProps> = ({
  initialAnswers,
  read = false,
  children,
}) => {
  const templateOWDQuestions = useAppSelector(
    (state) => state.spitems.elements.obj[templateOWDQuestionsListName],
  ) as Record<
    number,
    ListFieldsRecordType[typeof templateOWDQuestionsListName]
  >;

  const [totalAnswersObject, setTotalAnswersObject] = useState<
    Record<any, any>
  >(_.cloneDeep(initialAnswers));
  const [totalPercentage, setTotalPercentage] = useState(
    initialAnswers.answerPercentage || 0,
  );
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [percentOneQuestion, setPercentOneQuestion] = useState(
    100 / totalQuestions,
  );

  function changeTotalPercentage(v: number) {
    setTotalPercentage(v);
  }

  function changeTotalQuestions(v: number) {
    setTotalQuestions(v);
    setPercentOneQuestion(100 / v);
  }

  function changeTotalAnswersObject(key: string, v: any) {
    setTotalAnswersObject((prev) => ({ ...prev, [key]: v }));
  }

  function resetTotalPercentage() {
    setTotalPercentage(0);
    setTotalQuestions(0);
    setTotalAnswersObject({});
  }

  const contextValue: TemplateContextType = {
    percentOneQuestion,
    totalPercentage,
    totalQuestions,
    totalAnswersObject,
    changeTotalAnswersObject,
    changeTotalPercentage,
    changeTotalQuestions,
    resetTotalPercentage,
    read,
  };

  useEffect(() => {
    if (
      totalAnswersObject.template &&
      totalAnswersObject.answers &&
      Object.keys(totalAnswersObject.answers).length > 0
    ) {
      const answersKeys = Object.keys(totalAnswersObject.answers);
      let totalCount = 0;

      let newQuestionsWithoutSkip: Record<
        number,
        ListFieldsRecordType[typeof templateOWDQuestionsListName] | undefined
      > = Object.keys(templateOWDQuestions).reduce(
        (acc, key) => {
          acc[+key] = undefined;
          return acc;
        },
        {} as Record<number, undefined>,
      );

      let percentOneQuestion = 100 / Object.keys(templateOWDQuestions).length;

      const filterAnswersWithoutSkipped = answersKeys.reduce(
        (acc, key) => {
          const answer: OptionType | OptionType[] =
            totalAnswersObject.answers[key];

          if (_.isObject(answer) && !_.isArray(answer) && answer.ID === 3) {
            delete newQuestionsWithoutSkip[+key];
          } else {
            acc[key] = answer;
          }

          return acc;
        },
        {} as Record<string, OptionType | OptionType[]>,
      );

      percentOneQuestion = 100 / Object.keys(newQuestionsWithoutSkip).length;

      for (const [key, value] of Object.entries(filterAnswersWithoutSkipped)) {
        const question = templateOWDQuestions[+key];

        if (question.QuestionType === "radio" && !_.isArray(value)) {
          const isCorrect = +question.Answers[0].get_lookupId() === value.ID;

          if (isCorrect) {
            totalCount = totalCount + percentOneQuestion;
          }
        } else if (question.QuestionType === "rate") {
          const rate = totalAnswersObject.answers[question.ID];

          const percentActive = percentOneQuestion / 5; // цифру изменять в зависимости от диапазона выбора оценки сотрудника
          const gradeCount = percentActive * rate;

          totalCount = totalCount + gradeCount;
        } else if (_.isArray(value)) {
          const filtersAnswers = question.Answers.filter((a) =>
            value.find((v) => +a.get_lookupId() === v.ID),
          );

          if (
            filtersAnswers.length > 0 &&
            value.length <= filtersAnswers.length
          ) {
            if (filtersAnswers.length === question.Answers.length) {
              totalCount = totalCount + percentOneQuestion;
            }
          }
        }
      }

      changeTotalPercentage(totalCount);
    }
  }, [totalAnswersObject.answers]);

  return (
    <TemplateContext.Provider value={contextValue}>
      {children}
    </TemplateContext.Provider>
  );
};

async function checkAndUpdateNotificationsToHideByID(notificationID: number) {
  try {
    const updateItems: {
      items: ListFieldsRecordType[typeof notificationsListName][];
    } = await getItemsRequest({
      listName: notificationsListName,
      filters: { NotificationID: notificationID, Hide: false },
    });

    if (!updateItems.items.length) {
      throw new Error(
        `Не найдены элементы для проверки является ли пользователь последним который читает документ в notificationsListName по id ${notificationID}`,
      );
    }

    const isAllRead = updateItems.items.every((item) => item.Read);

    if (isAllRead) {
      const deleteMapItems = updateItems.items.map((item) => ({
        ID: item.ID,
        Hide: true,
      }));

      await updateItemRequest({
        listName: notificationsListName,
        body: {},
        bodyArr: deleteMapItems,
        update: false,
      });
    }
    return { status: isAllRead, items: updateItems.items };
  } catch (error) {
    console.error("error", error);
  }
}

function DrawerContent({
  toggleDrawer,
  item,
  read = false,
  zIndex = 70,
}: {
  toggleDrawer: (t: boolean) => void;
  item: TableBodyGetNotificationItem;
  read?: boolean;
  zIndex?: number;
}) {
  const isMobileView = isMobile();
  const dispatch = useAppDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [openSubmitModal, setOpenSubmitModal] = useState(false);
  const [submitModalContent, setSubmitModalContent] = useState<{
    title: string;
    message: string;
  }>({
    title: "",
    message: "",
  });
  const currentUser = useAppSelector((state) => selectCurrentUser(state));
  const users = useAppSelector((state) => selectUsers(state));
  const { changeStatus } = useStatusContext();

  const [query, setQuery] = useSearchParams();

  const [openOWDCheckList, setOpenOWDCheckList] = useState(false);
  const [openAuditCancelNotification, setOpenAuditCancelNotification] =
    useState(false);
  const [openOwdCancelNotification, setOpenOwdCancelNotification] =
    useState(false);
  const [loading, setLoading] = useState(false);

  const [checkList, setCheckList] = useState<Record<any, any> | null>(null);
  const [draftCheckListID, setDraftCheckListID] = useState<number | null>(
    item.CheckListID || null,
  );

  const [OWDState, setOWDState] = useState<{
    employee: PersonType | null;
    date: Date;
  }>({
    employee: null,
    date: new Date(),
  });

  const [isChecked, setIsChecked] = useState(_.isDate(item.Completed));

  /////////////////////////////////
  const {
    answersResult,
    minCorrectAnswerCount,
    notificationTestQuestionsID,
    percentResultTest,
    questions,
    resultPassingTest,
    showResultsTest,
    titleTest,
    availabilityTest,
    passingTestOpen,
    onResult,
    startPassingTest,
    getAnswersResult,
    setShowResultsTest,
    getPercentResultTest,
  } = useGetPassingTest(item);
  /////////////////////////////////

  function backButton() {
    const nextQuery = new URLSearchParams(query.toString());
    nextQuery.delete("notificationCard");
    setQuery(nextQuery);
    toggleDrawer(false);
  }

  function toggleDialog(state: boolean) {
    setOpenDialog(state);
  }

  function toggleSubmitModal(state: boolean) {
    setOpenSubmitModal(state);
  }

  function closeSubmitModal() {
    setOpenSubmitModal(false);
    backButton();

    dispatch(
      getNotificationsInfo({
        activeNotifyList: "get",
        listName: notificationsListName,
      }),
    );
  }

  function toggleOWDCheckList(state: boolean) {
    setOpenOWDCheckList(state);
  }

  function toggleAuditCancelNotification(state: boolean) {
    setOpenAuditCancelNotification(state);
  }

  function toggleOwdCancelNotification(state: boolean) {
    setOpenOwdCancelNotification(state);
  }

  function handleCheckboxChange() {
    setIsChecked(!isChecked);
  }

  async function submitAudit() {
    setLoading(true);

    try {
      if (item) {
        ///////////////////////////////////
        const resultTest = {
          NotificationID: item.ID,
          UserID: item.Author?.User?.ID,
          Title: `Результат ${titleTest}`,
          QuestionsID: notificationTestQuestionsID,
          AnswersResult: Object.keys(answersResult).filter(
            (key) => !!answersResult[key],
          ),
        };
        ///////////////////////////////////

        const body = {
          ID: item.ID,
          Read: true,
          Completed: new Date(),
          TestAnswerRate: percentResultTest,
        };

        ///////////////////////////////////
        if (Object.keys(answersResult).length) {
          await addItemRequest({
            listName: notificationTestResult,
            body: resultTest,
            updateReducer: false,
          });
        }
        ///////////////////////////////////

        await updateItemRequest({
          listName: notificationsListName,
          body,
          update: false,
        });

        const notifyData = await checkAndUpdateNotificationsToHideByID(
          item.NotificationID,
        );

        // поиск текущего на ознакомление с уведомлением

        if (emailsSender && notifyData) {
          if (notifyData.status) {
            const { items } = await getItemsRequest({
              listName: emailQueueListName,
              filters: { NotificationID: item.NotificationID },
            });

            if (items.length > 0) {
              const emailIDs = items.map((email) => ({ ID: email.ID }));

              const promises = chunkArray(emailIDs, 50).map((chunk) =>
                deleteEmail(chunk),
              );

              await Promise.all(promises);
            }

            const docLists = notifyData.items
              .filter(
                (n) => notifyData.items[0].EmployeeEmail === n.EmployeeEmail,
              )
              .map((item) => ({
                link: `${getUrlWithoutAttr("?notificationCard")}?notificationCard=${item.ID}`,
                title: item.Document.get_lookupValue(),
              }));

            let personalNumber = 0;

            if (notifyData.items[0].AuthorEmail) {
              const responseAbiGlobalID =
                (await getUserProperties(notifyData.items[0].AuthorEmail, [
                  "abiGlobalID",
                ])) || "";

              if (responseAbiGlobalID && responseAbiGlobalID.abiGlobalID) {
                personalNumber = responseAbiGlobalID.abiGlobalID;
              }
            }

            const emailBody = createEmailBodyByTemplate({
              subject: `Мои документы | Результаты ознакомления с документами`,
              user: {
                name:
                  nameFromEmail(notifyData.items[0].AuthorEmail)
                    .split(" ")
                    .reverse()
                    .join(" ") +
                  ` (${!!personalNumber ? personalNumber : "Нет данных"})`,
                email: notifyData.items[0].AuthorEmail,
              },
              document: {
                title: `Уведомляем Вас, что по следующему (-им) документу (-ам) ознакомления были завершены`,
                lists: docLists,
              },
              header:
                "Supply Portal -> Мои документы | Результаты ознакомления с документами",
            });

            const emailRequestBody = {
              Body: emailBody,
              DateToBeSentAt: new Date(),
              Title: "Ознакомление",
              Subject: "Мои документы | Ознакомление с документами",
              Recepients: notifyData.items[0].AuthorEmail.toLowerCase(), //? изменить если людей будет больше чем 1
              RepeatAt: 0,
            };

            await sendEmail(emailRequestBody);
          } else if (notifyData.items.length) {
            const userNotifyIsRead = notifyData.items.filter(
              (item) =>
                item.EmployeeEmail.toLowerCase() ===
                  currentUser.email.toLowerCase() && item.Read === false,
            );

            if (!userNotifyIsRead.length) {
              const { items } = await getItemsRequest({
                listName: emailQueueListName,
                filters: {
                  NotificationID: item.NotificationID,
                  Recepients: currentUser.email.toLowerCase() + "*",
                },
              });

              if (items.length > 0) {
                const emailIDs = items.map((email) => ({ ID: email.ID }));

                const promises = chunkArray(emailIDs, 50).map((chunk) =>
                  deleteEmail(chunk),
                );

                await Promise.all(promises);
              }
            }
          }
        }

        setOpenDialog(false);
        setSubmitModalContent({
          title: "Ознакомление завершено",
          message: "Вы успешно подтвердили ознакомление.",
        });
        setOpenSubmitModal(true);
      }
    } catch (error) {
      console.error(error, "Ошибка ознакомления => submitAudit");
    } finally {
      changeStatus(Date.now());
      setLoading(false);
    }
  }

  function openDocumentCard(id: number) {
    const newSearchParams = new URLSearchParams(query);
    newSearchParams.set("documentCardMobile", id.toString());
    newSearchParams.set("docFromNotification", "1");
    setQuery(newSearchParams);
  }

  async function removeExistingOWDChecklist(checkListID: number) {
    const { items } = await getItemsRequest({
      listName: checkListsOWDListName,
      filters: { CheckListID: checkListID },
    });

    if (items.length > 0) {
      await deleteItemRequest({
        listName: checkListsOWDListName,
        ID: items[0].ID,
        Ids: items.map((draftItem) => ({ ID: draftItem.ID })),
      });
    }
  }

  function buildOWDChecklistBodies(value: any, checkListID: number) {
    const bodies: Record<string, any>[] = [];

    for (const [key, answerValue] of Object.entries(value.answers || {})) {
      const body: Partial<
        Record<keyof ListFieldsType[typeof checkListsOWDListName], any>
      > = {
        Title: "",
        TemplateOWD: value.template.ID,
        Comment: value.comment ?? "",
        Rate: value.grade,
        AnswerRate: Math.round(value.answerPercentage),
        PassRate: value.template.PassRate,
        CheckListID: checkListID,
        AuthorEmail: currentUser.email.toLowerCase(),
        Question: +key,
      };

      if (!_.isArray(answerValue as OptionType) && _.isObject(answerValue as OptionType)) {
        body.QuestionType = (answerValue as OptionType).type;
        body.Answers = [(answerValue as OptionType).ID];
      } else if (_.isArray(answerValue as OptionType[])) {
        body.Answers = (answerValue as OptionType[]).map((v) => v.ID);
        body.QuestionType = (answerValue as OptionType[])[0]?.type || "select";
      } else if (_.isNumber(answerValue)) {
        body.Rate = answerValue;
        body.QuestionType = "rate";
      } else {
        body.QuestionType = "unknown";
      }

      bodies.push(body as Record<string, any>);
    }

    return bodies;
  }

  async function persistOWDDraft(
    value: any,
    employee: PersonType | null,
    options?: { complete?: boolean },
  ) {
    if (!value || !employee) return;

    let checkListID = draftCheckListID;

    if (!checkListID) {
      checkListID = (await addItemRequest({
        listName: checkListOWDIdsListName,
        body: { Title: item.ID.toString() },
        updateReducer: false,
      })) as number;
      setDraftCheckListID(checkListID);
    } else {
      await removeExistingOWDChecklist(checkListID);
    }

    const bodies = buildOWDChecklistBodies(value, checkListID);

    await Promise.all(
      bodies.map((body) =>
        addItemRequest({
          listName: checkListsOWDListName,
          body,
          updateReducer: false,
        }),
      ),
    );

    await updateItemRequest({
      listName: notificationsListName,
      body: {
        ID: item.ID,
        TestedEmployee: employee.Email.toLowerCase(),
        CheckListID: checkListID,
        TestAnswerRate: Math.round(value.answerPercentage),
        isPass: value.answerPercentage >= value.template.PassRate,
        TemplateOWDID: value.template.ID,
        ...(options?.complete
          ? {
              Completed: OWDState.date,
              Read: true,
            }
          : {}),
      },
      update: false,
    });
  }

  async function submitCheckList(value: any) {
    setLoading(true);
    try {
      setCheckList(value);
      await persistOWDDraft(value, OWDState.employee);
      dispatch(
        getNotificationsInfo({
          activeNotifyList: "get",
          listName: notificationsListName,
        }),
      );
      setOpenOWDCheckList(false);
    } catch (error) {
      console.error(error, "Ошибка при вызове => submitCheckList");
    } finally {
      setLoading(false);
      changeStatus(Date.now());
    }
  }

  async function submitOWD() {
    setLoading(true);
    try {
      if (checkList && OWDState.employee) {
        await persistOWDDraft(checkList, OWDState.employee, { complete: true });

        const notifyData = await checkAndUpdateNotificationsToHideByID(
          item.NotificationID,
        );

        if (notifyData) {
          if (notifyData.status) {
            const { items } = await getItemsRequest({
              listName: emailQueueListName,
              filters: { NotificationID: item.NotificationID },
            });

            const emailIDs = items.map((email) => ({ ID: email.ID }));

            if (emailIDs.length > 0) {
              await deleteEmail(emailIDs);
            }
          } else if (notifyData.items.length) {
            const userNotifyIsRead = notifyData.items.filter(
              (item) =>
                item.EmployeeEmail.toLowerCase() ===
                  currentUser.email.toLowerCase() && item.Read === false,
            );

            if (!userNotifyIsRead.length) {
              const { items } = await getItemsRequest({
                listName: emailQueueListName,
                filters: {
                  NotificationID: item.NotificationID,
                  Recepients: currentUser.email.toLowerCase() + "*",
                },
              });

              const emailIDs = items.map((email) => ({ ID: email.ID }));

              if (emailIDs.length > 0) {
                await deleteEmail(emailIDs);
              }
            }
          }
        }
      }
    } catch (error) {
      console.error(error, "Ошибка при вызове => submitOWD");
    } finally {
      setLoading(false);
      changeStatus(Date.now());
    }

    setSubmitModalContent({
      title: "OWD выполнено",
      message: "Вы успешно провели OWD.",
    });
    setOpenSubmitModal(true);
  }

  async function cancelNotification(item: TableBodyGetNotificationItem) {
    setLoading(true);
    try {
      dispatch(
        updateItem({
          listName: notificationsListName,
          body: {},
          bodyArr: [
            {
              ID: item.ID,
              Title: `Отклонено уведомление # ${item.ID}`,
              // Hide: true,
              // Read: true,
            },
          ],
        }),
      );

      // if (item.Author?.User?.Email.toLowerCase() !== currentUser.email.toLowerCase()) {
      if (item.NotificationType.ID === notificationStatuses.OWD) {
        if (item.Author?.User?.Email) {
          const emailBody = {
            Body: `Здравствуйте ${
              users[item.Author.User.Email.toLowerCase()] &&
              users[item.Author?.User?.Email?.toLowerCase()]?.["displayName"]
            },<br/><br/>${
              users[item.Employee.Email.toLowerCase()] &&
              users[item.Employee.Email.toLowerCase()]?.["displayName"]
            } Отклонил проведение OWD по документу: <br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${
              item.Document.ID
            }">${item.Document.Name}</a>`,
            DateToBeSentAt: new Date(),
            Title: "Мои Документы | Отклонение OWD",
            Subject: "Мои Документы | Отклонение OWD",
            Recepients: item.Author.User.Email,
            RepeatAt: 0,
          };

          await sendEmail(emailBody);
        }
      } else if (
        item.NotificationType.ID === notificationStatuses.acquainted ||
        item.NotificationType.ID === notificationStatuses.acquaintedTest ||
        item.NotificationType.ID === notificationStatuses.familiarization
      ) {
        const emailBody = {
          Body: `Здравствуйте ${
            users[item.Author.User.Email.toLowerCase()] &&
            users[item.Author?.User?.Email?.toLowerCase()]?.["displayName"]
          },<br/><br/>${
            users[item.Employee.Email.toLowerCase()] &&
            users[item.Employee.Email.toLowerCase()]?.["displayName"]
          } Отклонил ознакомление с документом: <br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${
            item.Document.ID
          }">${item.Document.Name}</a>`,
          DateToBeSentAt: new Date(),
          Title: "Мои Документы | Отклонение ознакомления",
          Subject: "Мои Документы | Отклонение ознакомления",
          Recepients: item.Author.User.Email,
          RepeatAt: 0,
        };

        await sendEmail(emailBody);
      }

      dispatch(
        getNotificationsInfo({
          activeNotifyList: "get",
          listName: notificationsListName,
        }),
      );
      // }
    } catch (error) {
      console.error(error, "Ошибка при вызове => cancelNotification");
    } finally {
      setOpenOwdCancelNotification(false);
      setOpenAuditCancelNotification(false);
      setLoading(false);
      backButton();
    }
  }

  useLayoutEffect(() => {
    if (item.NotificationType.ID === notificationStatuses.OWD) {
      async function fetchData() {
        setDraftCheckListID(item.CheckListID || null);

        if (read || item.CheckListID) {
          setOWDState({
            date: moment(item.ReviewDate.date, "DD.MM.YYYY").toDate(),
            employee: item.TestedEmployee
              ? {
                  Avatar: null,
                  Department: "",
                  Position: "",
                  ShortName: shortNameFromEmail(item.TestedEmployee),
                  Email: item.TestedEmployee,
                  Title: nameFromEmail(item.TestedEmployee),
                  ID: 0,
                  UserID: 0,
                  DisplayName: "",
                  PersonalNumber: 0,
                }
              : null,
          });

          const checkListResponse = await getItemsRequest({
            listName: checkListsOWDListName,
            filters: { CheckListID: item.CheckListID },
          });

          const obj = checkListResponse.items.reduce(
            (acc, cur) => {
              if (!acc.answerPercentage) {
                acc.answerPercentage = cur.AnswerRate;
              }

              if (!!cur.Comment && !acc.comment) {
                acc.comment = cur.Comment;
              }

              if (!acc.template) {
                acc.template = {
                  ID: cur.TemplateOWD.get_lookupId(),
                  Title: cur.TemplateOWD.get_lookupValue(),
                  Questions: [
                    {
                      Title: cur.Question.get_lookupValue(),
                      ID: +cur.Question.get_lookupId(),
                    },
                  ],
                  PassRate: cur.PassRate,
                };
              } else {
                if (acc.template.Questions) {
                  acc.template.Questions.push({
                    Title: cur.Question.get_lookupValue(),
                    ID: +cur.Question.get_lookupId(),
                  });
                }
              }

              if (!acc.answers) {
                acc.answers = {};
              }

              if (cur.QuestionType === "radio") {
                acc.answers[cur.Question.get_lookupId()] = {
                  ID: cur.Answers[0].get_lookupId(),
                  Title: cur.Answers[0].get_lookupValue(),
                  type: cur.QuestionType,
                };
              } else if (cur.QuestionType === "select") {
                acc.answers[cur.Question.get_lookupId()] = cur.Answers.map(
                  (answer) => ({
                    ID: answer.get_lookupId(),
                    Title: answer.get_lookupValue(),
                    type: cur.QuestionType,
                  }),
                );
              } else if (cur.QuestionType === "rate") {
                acc.answers[cur.Question.get_lookupId()] = cur.Rate;
              }

              return acc;
            },
            {} as Record<any, any>,
          );

          setCheckList(obj);

          if (obj.template) {
            // changeTotalAnswersObject("template", obj.template);

            dispatch(
              getItems({
                listName: templateOWDQuestionsListName,
                filters: {
                  ID: obj.template.Questions.map((q: { ID: number }) => q.ID),
                },
              }),
            );
          }
        }
      }

      fetchData();
    }
  }, [read, openOWDCheckList]);

  if (!item) {
    toggleDrawer(false);
    return null;
  }

  if (item.NotificationType.ID === notificationStatuses.OWD) {
    return (
      <FlexCol className={twMerge("divide-y", isMobileView && "bg-[#F9FAFB]")}>
        <header
          className={twMerge(
            "flex px-10 pt-10 pb-8 space-x-5 shrink-0",
            isMobileView &&
              "px-5 pt-5 pb-4 flex-col items-start gap-2 space-x-0",
          )}
        >
          <FlexCol>
            <h1 className="text-black">Проведение OWD</h1>
          </FlexCol>
          {isMobileView ? (
            <FlexRow className="items-center text-[14px] text-[#637381]">
              <span className="inline-block w-3 h-3 bg-[#DFE4EA] rounded-full mr-2 align-middle" />
              До {item.ReviewDate.date}г.
            </FlexRow>
          ) : (
            <FlexCol>
              <TGTag
                className={twMerge("text-black", "translate-y-1")}
                color={item.ReviewDate.expired ? "red" : "gray"}
              >
                до {item.ReviewDate.date}г.
              </TGTag>
            </FlexCol>
          )}
        </header>
        <FlexRow className={twMerge("p-10", isMobileView && "p-5")}>
          <FlexCol className="grow">
            <FlexRow className="justify-between items-center font-medium text-black">
              <FlexCol>
                <div
                  className={twMerge(
                    "text-[18px] shrink-0",
                    isMobileView && "text-[16px] leading-[24px]",
                  )}
                >
                  Документ
                </div>
              </FlexCol>
            </FlexRow>
            <FlexRow className={twMerge("mt-7.5", isMobileView && "mt-4")}>
              <FlexCol className="grow gap-y-2.5">
                <FlexRow
                  className={twMerge(
                    "gap-x-2.5 px-3.5 py-2.5 bg-[#F3F4F6] rounded-lg text-[14px] cursor-pointer",
                    isMobileView && "flex-col gap-y-1 text-[13px] leading-[20px]",
                  )}
                  onClick={() => openDocumentCard(item.Document.ID)}
                >
                  <span className="text-[#637381]">{item.Document.Code}</span>
                  <span className="break-words text-darkblue">
                    {item.Document.Name}
                  </span>
                </FlexRow>
              </FlexCol>
            </FlexRow>
          </FlexCol>
        </FlexRow>
        {!read && (
          <SelectReviewDateMobile
            title="Дата проведения OWD"
            modalTitle="Укажите дату проведения OWD"
            modalDescription="Дата проведения OWD"
            initial={OWDState.date}
            onResult={(date) => setOWDState({ ...OWDState, date: date })}
            filters={{
              start: moment().subtract(7, "day").toDate(),
              end: new Date(),
            }}
            zIndex={zIndex + 50}
          />
        )}
        {!read && (
          <Employee
            title="Кому проводят OWD"
            initial={OWDState.employee}
            onResult={async (emp) => {
              setOWDState({ ...OWDState, employee: emp });

              if (emp) {
                try {
                  await updateItemRequest({
                    listName: notificationsListName,
                    body: {
                      ID: item.ID,
                      TestedEmployee: emp.Email.toLowerCase(),
                    },
                    update: false,
                  });

                  dispatch(
                    getNotificationsInfo({
                      activeNotifyList: "get",
                      listName: notificationsListName,
                    }),
                  );
                } catch (error) {
                  console.error(error, "Ошибка при вызове => saveOWDEmployee");
                }
              }
            }}
            isMobileView={isMobileView}
            zIndex={zIndex + 30}
            buttonElement={
              !!checkList ? (
                <FlexCol
                  className={twMerge(
                    "text-[18px] font-medium whitespace-nowrap",
                    isMobileView && "text-[16px] leading-[22px]",
                  )}
                >
                  <FlexRow className="space-x-1">
                    <span
                      className={twMerge(
                        "inline-block",
                        checkList.answerPercentage === 0
                          ? ""
                          : checkList.answerPercentage <
                              checkList.template.PassRate
                            ? "text-[#BA0C2F]"
                            : "text-[#22AD5C]",
                      )}
                    >
                      {Math.round(checkList.answerPercentage)}%
                    </span>
                    <span>/</span>
                    <span className="inline-block">
                      {checkList.template.PassRate}%
                    </span>
                  </FlexRow>
                </FlexCol>
              ) : null
            }
          />
        )}

        {read && (
          <>
            <FlexRow
              className={twMerge(
                "p-10 border-t text-[18px] flex space-x-2 text-black font-medium",
                isMobileView && "p-5 text-[16px] leading-[22px]",
              )}
            >
              <span>Отправитель:</span>
              <UserAvatarItem
                item={{
                  name: nameFromEmail(item.Author.User.Email),
                  shortName: shortNameFromEmail(item.Author.User.Email),
                  email: item.Author.User.Email,
                  id: item.Author.User.ID,
                }}
                single={true}
              />
            </FlexRow>
            <FlexRow
              className={twMerge(
                "p-10 border-t text-[18px] justify-between text-black font-medium",
                isMobileView && "p-5 text-[16px] leading-[22px] flex-col gap-4",
              )}
            >
              <FlexCol>
                <FlexRow
                  className={twMerge(
                    "space-x-2",
                    isMobileView && "space-x-0 flex-col gap-3",
                  )}
                >
                  <FlexCol>Кто провел OWD</FlexCol>
                  <FlexCol>
                    <UserAvatarItem
                      item={{
                        name: nameFromEmail(item.Employee.Email),
                        shortName: shortNameFromEmail(item.Employee.Email),
                        email: item.Employee.Email,
                        id: item.Employee.ID,
                      }}
                      single={true}
                    />
                  </FlexCol>
                </FlexRow>
              </FlexCol>
              {read && (
                <FlexCol>
                  <FlexRow
                    className={twMerge(
                      "text-[18px] text-black font-medium",
                      isMobileView && "text-[16px] leading-[22px]",
                    )}
                  >
                    <TGCheckbox
                      disabled={true}
                      isChecked={isChecked}
                      onChange={handleCheckboxChange}
                      labelClass={twMerge(
                        isMobileView &&
                          "text-black text-[16px] leading-[22px] font-medium",
                      )}
                    >
                      Я заполнил(-а) и подтверждаю результат OWD
                    </TGCheckbox>
                  </FlexRow>
                </FlexCol>
              )}
            </FlexRow>
            {item.TestedEmployee && (
              <FlexRow
                className={twMerge(
                  "p-10 border-t text-[18px] justify-between text-black font-medium",
                  isMobileView && "p-5 text-[16px] leading-[22px] flex-col gap-4",
                )}
              >
                <FlexCol>
                  <FlexRow
                    className={twMerge(
                      "space-x-2",
                      isMobileView && "space-x-0 flex-col gap-3",
                    )}
                  >
                    <FlexCol>
                      <span>Кому проводят OWD</span>
                    </FlexCol>
                    <FlexCol>
                      <UserAvatarItem
                        item={{
                          name: nameFromEmail(item.TestedEmployee),
                          shortName: shortNameFromEmail(item.TestedEmployee),
                          email: item.TestedEmployee,
                        }}
                        single={true}
                      />
                    </FlexCol>
                  </FlexRow>
                </FlexCol>
                {!!checkList && (
                  <FlexCol
                    className={twMerge(
                      "whitespace-nowrap",
                      isMobileView && "text-[16px] leading-[22px]",
                    )}
                  >
                    <FlexRow className="space-x-1">
                      <span
                        className={twMerge(
                          "inline-block",
                          checkList.answerPercentage === 0
                            ? ""
                            : checkList.answerPercentage <
                                checkList.template.PassRate
                              ? "text-[#BA0C2F]"
                              : "text-[#22AD5C]",
                        )}
                      >
                        {Math.round(checkList.answerPercentage)}%
                      </span>
                      <span>/</span>
                      <span className="inline-block">
                        {checkList.template.PassRate}%
                      </span>
                    </FlexRow>
                  </FlexCol>
                )}
              </FlexRow>
            )}
          </>
        )}

        {!read && (
          <FlexRow
            className={twMerge(
              !!checkList ? "text-black" : "",
              "gap-x-2 p-10 font-medium text-[18px]",
              isMobileView && "p-5 text-[16px] leading-[22px]",
            )}
          >
            <TooltipItem
              disable={!!checkList || !!OWDState.employee}
              tooltipsText="Сначала выберите сотрудника"
              position="right"
            >
              Чек-лист:{!!checkList ? " заполнен" : " не заполнен"}
            </TooltipItem>
          </FlexRow>
        )}
        {!read && (
          <FlexCol
            className={twMerge(
              "p-10 border-t text-[18px] text-black font-medium",
              isMobileView && "p-5 text-[16px] leading-[22px]",
            )}
          >
            <TooltipItem
              disable={!!checkList}
              tooltipsText="Сначала заполните чек-лист"
              position="right"
            >
              <TGCheckbox
                disabled={!checkList}
                isChecked={isChecked}
                onChange={handleCheckboxChange}
                labelClass={twMerge(
                  isMobileView &&
                    "text-black text-[16px] leading-[22px] font-medium",
                )}
              >
                Я заполнил(-а) и подтверждаю результат OWD
              </TGCheckbox>
            </TooltipItem>
            {!checkList && (
              <span className="mt-2 text-[13px] text-[#BA0C2F]">
                Сначала заполните чек-лист
              </span>
            )}
          </FlexCol>
        )}
        <footer
          className={twMerge(
            "flex justify-between p-10 shrink-0",
            isMobileView && "p-5 flex-col gap-3",
          )}
        >
          <TGButton
            className={twMerge(isMobileView && "w-full justify-center")}
            disabled={loading}
            onClick={backButton}
          >
            {read ? "Закрыть" : "Отмена"}
          </TGButton>
          <div
            className={twMerge(
              "space-x-2.5",
              isMobileView && "space-x-0 space-y-3 w-full",
            )}
          >
            {!_.isDate(item.Completed) && (
              <TGButton
                type="button"
                className={twMerge(
                  "text-red",
                  isMobileView && "w-full justify-center h-[46px] text-[14px]",
                )}
                onClick={() => {
                  toggleOwdCancelNotification(true);
                }}
              >
                Отклонить OWD
              </TGButton>
            )}
            {read ? (
              <TGButton
                className={twMerge(
                  isMobileView && "w-full justify-center h-[46px] text-[14px]",
                )}
                disabled={!OWDState.employee || !checkList}
                onClick={() => setOpenOWDCheckList(true)}
              >
                Перейти к чек-листу
              </TGButton>
            ) : (
              <TGButton
                className={twMerge(
                  isMobileView && "w-full justify-center h-[46px] text-[14px]",
                )}
                disabled={!OWDState.employee}
                onClick={() => setOpenOWDCheckList(true)}
              >
                Перейти к чек-листу
              </TGButton>
            )}
            {!read && (
              <TGButton
                className={twMerge(
                  isMobileView && "w-full justify-center h-[46px] text-[14px]",
                )}
                disabled={!isChecked}
                color="bluedark"
                onClick={submitOWD}
              >
                Подтвердить результат OWD
              </TGButton>
            )}
          </div>
        </footer>

        {/* Модальное окно для чек-листа начало */}
        <DrawerComponent
          zIndex={(zIndex && zIndex + 10) || 70}
          open={openOWDCheckList}
          toggleDrawer={toggleOWDCheckList}
          percentage="87"
        >
          <TemplateProvider initialAnswers={checkList || {}} read={read}>
            <DrawerOWDCheckList
              zIndex={(zIndex && zIndex + 10) || 70}
              OWDState={OWDState}
              item={item}
              toggleOWDCheckList={toggleOWDCheckList}
              onSubmitCheckList={submitCheckList}
            />
          </TemplateProvider>
        </DrawerComponent>

        {/* Модальное окно для Проведение OWD начало */}
        <Modal
          zIndex={zIndex + 30}
          open={openSubmitModal}
          toggleDialog={toggleSubmitModal}
          hideXMarkIcon={true}
          modalClassName={twMerge(
            isMobileView && "!min-h-0 !w-[calc(100vw-24px)] !min-w-0 rounded-xl py-5",
          )}
          autoClose={autoCloseModal}
          onAutoClose={() => {
            backButton();
            dispatch(getNotificationsInfo({ listName: notificationsListName }));
          }}
          allowIOSScroll
        >
          <header className={twMerge(isMobileView ? "px-5 pb-2 text-black" : "px-10 pb-4 text-black")}>
            <h1>{submitModalContent.title}</h1>
          </header>

          <div className={twMerge(isMobileView ? "px-5 py-4 text-black grow" : "px-10 py-5 text-black grow")}>
            <div>{submitModalContent.message}</div>
          </div>

          <footer
            className={twMerge(
              isMobileView
                ? "mt-2 flex flex-col gap-3 border-t px-5 pt-4"
                : "flex justify-center px-10 pt-10 mt-4 border-t",
            )}
          >
            <TGButton
              color="bluedark"
              className={twMerge(
                isMobileView && "h-[44px] w-full justify-center text-[14px]",
              )}
              onClick={() => {
                closeSubmitModal();
              }}
            >
              Закрыть
            </TGButton>
          </footer>
        </Modal>

        <Modal
          zIndex={110}
          open={openOwdCancelNotification}
          toggleDialog={toggleOwdCancelNotification}
          modalClassName={twMerge(
            isMobileView && "!min-h-0 !w-[calc(100vw-24px)] !min-w-0 rounded-xl py-5",
          )}
        >
          <header className={twMerge(isMobileView ? "px-5 pb-2" : "px-10 pb-4")}>
            <h2>Подтвердите действие</h2>
          </header>

          <div className={twMerge(isMobileView ? "px-5 py-4 grow" : "px-10 py-5 grow")}>
            <p className={twMerge(isMobileView ? "text-base" : "text-lg")}>
              Вы уверены, что хотите отклонить OWD?
            </p>
          </div>

          <footer
            className={twMerge(
              isMobileView
                ? "mt-2 flex flex-col gap-3 border-t px-5 pt-4"
                : "flex justify-between px-10 pt-10 mt-4 border-t",
            )}
          >
            <TGButton color="bluedark" onClick={() => cancelNotification(item)}>
              Да, отклонить
            </TGButton>
            <TGButton onClick={() => toggleOwdCancelNotification(false)}>
              Отмена
            </TGButton>
          </footer>
        </Modal>
        <Modal
          zIndex={100}
          modalClassName="min-h-0 min-w-min text-center"
          open={loading}
          toggleDialog={() => false}
          hideXMarkIcon={true}
        >
          <header className="px-10 pb-4">
            <h2>Идет сохранение данных</h2>
          </header>

          <div className="justify-center items-center px-10 space-y-5">
            <p className="text-lg">Пожалуйста подождите...</p>
            <Loading />
          </div>
        </Modal>
      </FlexCol>
    );
  }

  return (
    <FlexCol className={twMerge(isMobileView && "bg-[#F9FAFB]")}>
      <header
        className={twMerge(
          "flex flex-row items-center px-10 pt-10 pb-8 space-x-5 text-black border-b",
          isMobileView && "px-5 pt-5 pb-4 flex-col items-start gap-2 space-x-0",
        )}
      >
        <FlexCol>
          <h2 className="text-[16px] leading-8 font-medium text-[#111827]">
            Ознакомление
          </h2>
        </FlexCol>
        {isMobileView ? (
          <FlexRow className="items-center text-[14px] text-[#637381]">
            <span className="inline-block w-3 h-3 bg-[#DFE4EA] rounded-full mr-2 align-middle" />
            До {item.ReviewDate.date}г.
          </FlexRow>
        ) : (
          <FlexCol>
            <TGTag
              className={twMerge("text-black", "translate-y-1")}
              color={item.ReviewDate.expired ? "red" : "gray"}
            >
              до {item.ReviewDate.date}г.
            </TGTag>
          </FlexCol>
        )}
      </header>
      <FlexRow className={twMerge("p-10", isMobileView && "p-5")}>
        <FlexCol className="grow">
          <h3
            className={twMerge(
              "font-medium text-black mb-7.5",
              isMobileView && "text-[16px] mb-4",
            )}
          >
            Документ
          </h3>
          <div className="border-b">
            {!isChecked && (
              <FlexRow
                className={twMerge(
                  "px-3.5 py-2.5 bg-[#FEF3C7] border rounded-lg text-[14px] w-fit border-[#F2A900] mb-2.5",
                  isMobileView && "w-full text-[13px]",
                )}
              >
                Пожалуйста, перейдите по ссылке ниже на карточку документа,
                скачайте его и ознакомьтесь с содержимым
              </FlexRow>
            )}

            <FlexRow>
              <FlexCol className="grow gap-y-2.5">
                <FlexCol
                  className={twMerge(
                    "gap-x-2.5 px-3.5 py-2.5 bg-[#F3F4F6] rounded-lg text-[13px] cursor-pointer",
                    isMobileView && "text-[13px]",
                  )}
                  onClick={() => openDocumentCard(item.Document.ID)}
                >
                  <span>{item.Document.Code}</span>
                  <span className="text-darkblue">{item.Document.Name}</span>
                </FlexCol>
              </FlexCol>
            </FlexRow>
          </div>
        </FlexCol>
      </FlexRow>

      {_.isDate(item.Completed) && (
        <FlexRow
          className={twMerge(
            "p-10 border-t text-[18px] flex space-x-2 text-black font-medium",
            isMobileView && "p-5 text-[14px]",
          )}
        >
          <span>Отправитель:</span>{" "}
          <UserAvatarItem
            item={{
              name: item.Author.User.Name,
              shortName: shortNameFromEmail(item.Author.User.Email),
              email: item.Author.User.Email,
              id: item.Author.User.ID,
            }}
            single={true}
          />
        </FlexRow>
      )}

      {_.isDate(item.Completed) && (
        <FlexRow
          className={twMerge(
            "p-10 border-t text-[18px] flex justify-between text-black font-medium",
            isMobileView && "p-5 text-[14px] flex-col gap-3",
          )}
        >
          <FlexCol>
            <FlexRow className="space-x-2">
              <FlexCol>Сотрудник:</FlexCol>
              <FlexCol>
                <UserAvatarItem
                  item={{
                    name: item.Employee.Name,
                    shortName: shortNameFromEmail(item.Employee.Email),
                    email: item.Employee.Email,
                    id: item.Employee.ID,
                  }}
                  single={true}
                />
              </FlexCol>
            </FlexRow>
          </FlexCol>
          {_.isDate(item.Completed) && (
            <FlexCol>
              <FlexRow className="text-[18px] text-black font-medium">
                <TooltipItem
                  disable={
                    !item.Test ||
                    resultPassingTest === TEST_STATUSES.COMPLETE_SUCCESSFUL
                  }
                  position="right"
                  tooltipsText="Сначала пройдите тест"
                >
                  <TGCheckbox
                    isChecked={true}
                    onChange={handleCheckboxChange}
                    disabled={true}
                    labelClass="text-black text-[14px] leading-[18px] font-medium"
                  >
                    Я прочитал(-а) и подтверждаю факт ознакомления с документом
                  </TGCheckbox>
                </TooltipItem>
              </FlexRow>
            </FlexCol>
          )}
        </FlexRow>
      )}

      {/* ///////////////////////////////////////// */}
      {availabilityTest && (
        <FlexRow
          className={twMerge(
            "p-10 border-t text-[18px] flex justify-between text-black font-medium",
            isMobileView && "p-5 text-[14px]",
          )}
        >
          Тестирование:
          {resultPassingTest === TEST_STATUSES.COMPLETE_SUCCESSFUL
            ? " пройдено успешно"
            : " не пройдено"}
          {resultPassingTest === TEST_STATUSES.COMPLETE_SUCCESSFUL ? (
            <SuccessfullyPassingTest />
          ) : resultPassingTest === TEST_STATUSES.COMPLETE_WITH_ERROR ? (
            <RejectedPassingTest />
          ) : null}
        </FlexRow>
      )}
      {/* ///////////////////////////////////////// */}

      {!!item.Author.Comment && (
        <FlexRow
          className={twMerge(
            "p-10 border-t text-[18px] flex justify-between text-black font-medium",
            isMobileView && "p-5 text-[14px]",
          )}
        >
          Комментарий: {item.Author.Comment}
        </FlexRow>
      )}
      {!_.isDate(item.Completed) && (
        <FlexRow
          className={twMerge(
            "p-10 border-t text-[18px] text-black font-medium",
            isMobileView && "p-5 text-[14px]",
          )}
        >
          <TooltipItem
            disable={
              !item.Test ||
              resultPassingTest === TEST_STATUSES.COMPLETE_SUCCESSFUL
            }
            position="right"
            tooltipsText="Сначала пройдите тест"
          >
            <TGCheckbox
              isChecked={isChecked}
              onChange={handleCheckboxChange}
              disabled={
                availabilityTest
                  ? resultPassingTest === TEST_STATUSES.NOT_STARTED ||
                    resultPassingTest === TEST_STATUSES.COMPLETE_WITH_ERROR
                  : false
              }
            >
              Я прочитал(-а) и подтверждаю факт ознакомления с документом
            </TGCheckbox>
          </TooltipItem>
        </FlexRow>
      )}
      <footer
        className={twMerge(
          "flex flex-row justify-between items-center p-10 text-black border-t",
          isMobileView && "p-5 flex-col items-stretch gap-3",
        )}
      >
        <TGButton
          className={twMerge(
            isMobileView && "w-full justify-center h-[46px] text-[14px]",
          )}
          disabled={loading}
          onClick={backButton}
        >
          {_.isDate(item.Completed) ? "Закрыть" : "Отмена"}
        </TGButton>
        <div
          className={twMerge(
            "flex gap-[10px]",
            isMobileView && "w-full flex-col",
          )}
        >
          {/* ///////////////////////////////////////// */}

          {!_.isDate(item.Completed) && (
            <div className={twMerge(isMobileView && "w-full")}>
              <TGButton
                className={twMerge(
                  "text-red",
                  isMobileView && "w-full justify-center h-[46px] text-[14px]",
                )}
                onClick={() => {
                  toggleAuditCancelNotification(true);
                }}
              >
                Отклонить ознакомление
              </TGButton>
            </div>
          )}
          <div
            className={twMerge(
              "flex gap-[10px]",
              isMobileView && "w-full flex-col",
            )}
          >
            {availabilityTest &&
              (resultPassingTest === TEST_STATUSES.COMPLETE_SUCCESSFUL ? (
                <TGButton
                  className={twMerge(
                    isMobileView &&
                      "w-full justify-center h-[46px] text-[14px]",
                  )}
                  color="white"
                  onClick={() => {
                    startPassingTest();
                    setShowResultsTest(true);
                  }}
                >
                  Посмотреть результаты теста
                </TGButton>
              ) : (
                <TGButton
                  className={twMerge(
                    isMobileView &&
                      "w-full justify-center h-[46px] text-[14px]",
                  )}
                  color="white"
                  onClick={() => {
                    startPassingTest();
                    setShowResultsTest(false);
                  }}
                >
                  Перейти к тесту
                </TGButton>
              ))}
          </div>
          {/* ///////////////////////////////////////// */}

          {!_.isDate(item.Completed) && (
            <TGButton
              className={twMerge(
                isMobileView && "w-full justify-center h-[46px] text-[14px]",
              )}
              disabled={!isChecked || loading}
              color="bluedark"
              onClick={submitAudit}
            >
              Подтвердить ознакомление
            </TGButton>
          )}
        </div>
      </footer>
      {/* ///////////////////////////////////////// */}
      <DrawerComponent
        percentage="87"
        zIndex={zIndex + 20}
        open={passingTestOpen}
        toggleDrawer={startPassingTest}
      >
        <PassingTestContext.Provider
          value={{
            questions,
            minCorrectAnswerCount,
            showResultsTest,
            answersResult,
            percentResultTest,
            getPercentResultTest,
            startPassingTest,
            onResult,
            getAnswersResult,
          }}
        >
          <PassingTestMobile zIndex={zIndex + 30} />
        </PassingTestContext.Provider>
      </DrawerComponent>
      {/* ///////////////////////////////////////// */}

      <Modal
        zIndex={zIndex + 30}
        open={openSubmitModal}
        toggleDialog={toggleSubmitModal}
        hideXMarkIcon={true}
        modalClassName={twMerge(
          isMobileView && "!min-h-0 !w-[calc(100vw-24px)] !min-w-0 rounded-xl py-5",
        )}
      >
        <header className={twMerge(isMobileView ? "px-5 pb-2 text-black" : "px-10 pb-4 text-black")}>
          <h1>{submitModalContent.title}</h1>
        </header>

        <div className={twMerge(isMobileView ? "px-5 py-4 text-black grow" : "px-10 py-5 text-black grow")}>
          <div>{submitModalContent.message}</div>
        </div>

        <footer
          className={twMerge(
            isMobileView
              ? "mt-2 flex flex-col gap-3 border-t px-5 pt-4"
              : "flex justify-center px-10 pt-10 mt-4 border-t",
          )}
        >
          <TGButton
            color="bluedark"
            className={twMerge(
              isMobileView && "h-[44px] w-full justify-center text-[14px]",
            )}
            onClick={() => {
              closeSubmitModal();
            }}
          >
            Закрыть
          </TGButton>
        </footer>
      </Modal>

      <Modal
        zIndex={zIndex + 30}
        open={openAuditCancelNotification}
        toggleDialog={toggleAuditCancelNotification}
        modalClassName={twMerge(
          isMobileView && "!min-h-0 !w-[calc(100vw-24px)] !min-w-0 rounded-xl py-5",
        )}
      >
        <header className={twMerge(isMobileView ? "px-5 pb-2" : "px-10 pb-4")}>
          <h2>Подтвердите действие</h2>
        </header>

        <div className={twMerge(isMobileView ? "px-5 py-4 grow" : "px-10 py-5 grow")}>
          <p className={twMerge(isMobileView ? "text-base" : "text-lg")}>
            Вы уверены, что хотите отклонить уведомление?
          </p>
        </div>

        <footer
          className={twMerge(
            isMobileView
              ? "mt-2 flex flex-col gap-3 border-t px-5 pt-4"
              : "flex justify-between px-10 pt-10 mt-4 border-t",
          )}
        >
          <TGButton color="bluedark" onClick={() => cancelNotification(item)}>
            Да, отклонить
          </TGButton>
          <TGButton onClick={() => toggleAuditCancelNotification(false)}>
            Отмена
          </TGButton>
        </footer>
      </Modal>

      <Modal
        zIndex={100}
        modalClassName="min-h-0 min-w-min text-center"
        open={loading}
        toggleDialog={() => false}
        hideXMarkIcon={true}
      >
        <header className="px-10 pb-4">
          <h2>Идет сохранение данных</h2>
        </header>

        <div className="justify-center items-center px-10 space-y-5">
          <p className="text-lg">Пожалуйста подождите...</p>
          <Loading />
        </div>
      </Modal>
    </FlexCol>
  );
}

type TemplateType = ListFieldsType[typeof templatesOWDListName];

function DrawerOWDCheckList({
  zIndex = 70,
  OWDState,
  item,
  toggleOWDCheckList,
  onSubmitCheckList,
}: {
  zIndex?: number;
  item: TableBodyGetNotificationItem;
  OWDState: { employee: PersonType | null; date: Date };
  toggleOWDCheckList: (value: boolean) => void;
  onSubmitCheckList: (value: any) => void;
}) {
  const dispatch = useAppDispatch();
  const isMobileView = isMobile();

  const {
    totalPercentage,
    totalAnswersObject,
    resetTotalPercentage,
    changeTotalAnswersObject,
    read,
  } = useTemplateContext();

  const [templates, setTemplates] = useState<TemplateType[]>(
    totalAnswersObject.template ? [totalAnswersObject.template] : [],
  );
  const id = item.ID;

  const { data: templatesOWD, status: statusTemplatesOWD } =
    useGetSelect(templatesOWDListName);

  const templateOWDQuestions = useAppSelector((state) =>
    selectItems(state, templateOWDQuestionsListName),
  ) as ListFieldsType[typeof templateOWDQuestionsListName][];

  function changeTemplate(items: TemplateType[]) {
    setTemplates(items);
    resetTotalPercentage();
  }

  useEffect(() => {
    dispatch(
      getItems({
        listName: templatesOWDListName,
        filters: {
          Hide: false,
        },
      }),
    );
  }, [dispatch]);

  return (
    <>
      <header
        className={twMerge(
          "flex justify-between items-end px-10 pt-10 pb-8 space-x-5 text-black shrink-0",
          isMobileView && "flex-col items-start gap-1 px-5 pt-5 pb-4 space-x-0",
        )}
      >
        <FlexCol>
          <h1>Чек-лист</h1>
        </FlexCol>
        <FlexCol
          className={twMerge(
            "text-[18px] font-medium whitespace-nowrap",
            isMobileView && "text-[14px] leading-[20px]",
          )}
        >
          <FlexRow className="space-x-2.5">
            {templates.length > 0 ? (
              <>
                <span
                  className={twMerge(
                    "inline-block",
                    totalPercentage === 0
                      ? ""
                      : Math.round(totalPercentage) < templates[0].PassRate
                        ? "text-[#BA0C2F]"
                        : "text-[#22AD5C]",
                  )}
                >
                  {Math.round(totalPercentage)}%
                </span>
                <span>/</span>
                <span className="inline-block">{templates[0].PassRate}%</span>

                {!isMobileView && (
                  <DownloadPDFButton
                    data={{
                      document: {
                        Code: item.Document.Code,
                        Title: item.Document.Name,
                      },
                      checkedBy: item.Employee.Email,
                      reviewedBy: OWDState.employee!.Email || "",
                      sendedBy: item.Author.User.Email,
                      reviewDate: item.ReviewDate.date,
                      todayDate: read
                        ? moment(item.Completed, "DD.MM.YYYY").format(
                            "DD.MM.YYYY",
                          )
                        : moment(OWDState.date).format("DD.MM.YYYY"),
                      title: templates[0].Title,
                      completionPercentage: totalPercentage,
                      targetPercentage: templates[0].PassRate,
                      questions: templateOWDQuestions,
                      comment: totalAnswersObject.comment,
                      answers: totalAnswersObject.answers,
                    }}
                  />
                )}
              </>
            ) : (
              <span className="inline-block">0%</span>
            )}
          </FlexRow>
        </FlexCol>
      </header>

      <FlexRow className={twMerge("px-10 pb-10 custom-selects", isMobileView && "px-5 pb-5")}>
        <FlexCol className="w-full">
          <MyListbox
            disable={read}
            multi={false}
            list={templatesOWD}
            value={templates}
            onChange={changeTemplate}
            label="Шаблон OWD"
            required={true}
            placeholder="Не выбрано"
            loading={statusTemplatesOWD === "LOADING"}
            className="!px-5"
          />
        </FlexCol>
      </FlexRow>
      {templates && templates.length > 0 && (
        <TemplateQuestions
          isMobileView={isMobileView}
          template={templates[0]}
          questions={templateOWDQuestions}
        />
      )}
      {totalAnswersObject.comment &&
        totalAnswersObject.comment.length > 0 &&
        read && (
          <FlexRow className={twMerge("p-10 py-[5px]", isMobileView && "px-5 py-0")}>
            <Card>
              <h3 className="mb-5 font-medium text-black">Обратная связь</h3>
              <Comment
                read={read}
                onChange={(value) => changeTotalAnswersObject("comment", value)}
                initial={totalAnswersObject.comment}
              />
            </Card>
          </FlexRow>
        )}
      {!read && (
        <FlexRow
          className={twMerge(
            "p-10 py-[5px]",
            isMobileView && "px-5 pt-0 pb-3",
          )}
        >
          <Card>
            <h3 className="mb-5 font-medium text-black">Обратная связь</h3>
            <Comment
              read={read}
              onChange={(value) => changeTotalAnswersObject("comment", value)}
              initial={totalAnswersObject.comment}
            />
          </Card>
        </FlexRow>
      )}

      {id && (
        <FlexRow
          className={twMerge(
            "p-10",
            isMobileView && "px-5 pt-0 pb-5",
          )}
        >
          <Card>
            <h3 className="mb-5 font-medium text-black">Действия</h3>
            <AddActionInComponent
              typeModule="OWD"
              idModule={id}
              CustomStyles="owd_table"
              hideMobileList={false}
              noUsersRequest={isMobileView}
              mobileModalMode={isMobileView}
              mobileModalZIndex={zIndex + 40}
            />
          </Card>
        </FlexRow>
      )}

      <footer
        className={twMerge(
          "flex justify-between px-10 pt-10 mt-4",
          isMobileView &&
            "mt-4 flex-col gap-3 border-t px-5 pt-5 pb-5 [padding-bottom:calc(1.25rem+env(safe-area-inset-bottom))]",
        )}
      >
        {!read && (
          <TGButton
            color="bluedark"
            disabled={
              !(
                !!totalAnswersObject.answers &&
                Object.keys(totalAnswersObject.answers).length ===
                  Object.keys(templateOWDQuestions).length
              )
            }
            onClick={() =>
              onSubmitCheckList({
                ...totalAnswersObject,
                answerPercentage: totalPercentage,
              })
            }
            className={twMerge(
              isMobileView && "h-[44px] w-full justify-center text-[14px]",
            )}
          >
            Сохранить
          </TGButton>
        )}
        <TGButton
          onClick={() => toggleOWDCheckList(false)}
          className={twMerge(
            isMobileView && "h-[44px] w-full justify-center text-[14px]",
          )}
        >
          {read ? "Закрыть" : "Назад"}
        </TGButton>
      </footer>
    </>
  );
}

type QuestionType = ListFieldsType[typeof templateOWDQuestionsListName];

function TemplateQuestions({
  isMobileView = false,
  template,
  questions,
}: {
  isMobileView?: boolean;
  template: TemplateType;
  questions: QuestionType[];
}) {
  const dispatch = useAppDispatch();
  const { changeTotalAnswersObject } = useTemplateContext();
  const statusTemplateOWDQuestions = useAppSelector((state) =>
    selectGetStatus(state, templateOWDQuestionsListName),
  );

  useEffect(() => {
    if (template) {
      changeTotalAnswersObject("template", template);

      dispatch(
        getItems({
          listName: templateOWDQuestionsListName,
          filters: { ID: template.Questions.map((q) => q.ID) },
        }),
      );
    }
  }, [dispatch, template]);

  if (statusTemplateOWDQuestions === "LOADING") return <Loading />;

  return (
    <div className={twMerge("px-10 space-y-[10px] py-[5px]", isMobileView && "px-5")}>
      <h3 className="mb-2.5 font-medium">Вопросы</h3>

      <FlexRow className="flex-wrap space-y-[10px]">
        {questions
          .sort((a, b) => a.Title.localeCompare(b.Title))
          .map((question) => (
            <TemplateQuestion
              key={question.ID}
              question={question}
              questionLength={questions.length}
            />
          ))}
      </FlexRow>
    </div>
  );
}

function Comment({
  read,
  initial = "",
  onChange,
}: {
  read?: boolean;
  initial?: string;
  onChange: (value: string) => void;
}) {
  const [comment, setComment] = useState(initial);

  function changeComment(value: string) {
    setComment(value);
    onChange(value);
  }

  return (
    <>
      {!read ? (
        <SearchUI
          disabled={read}
          search={false}
          heightAuto={true}
          textArea={true}
          placeholder={
            read
              ? "Комментарий не был указан"
              : "Введите комментарий в свободной форме"
          }
          defaultValue={comment}
          onClick={changeComment}
        />
      ) : (
        <div className="inline-block px-5 py-3 w-full text-black rounded-md bg-gray3">
          {comment ? (
            <pre className="font-[inherit]">{comment}</pre>
          ) : (
            "Комментарий не был указан"
          )}
        </div>
      )}
    </>
  );
}

function getSelectedMapByArray(
  answers: OptionType[] | undefined,
  questionType: "radio" | "select",
) {
  return answers
    ? answers.reduce(
        (acc: Map<number, OptionType>, cur: OptionType) =>
          acc.set(cur.ID, { ...cur, type: questionType }),
        new Map(),
      )
    : new Map();
}

const schema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames ?? []), "u"],
};

function TemplateQuestion({
  question,
}: {
  question: QuestionType;
  questionLength: number;
}) {
  const { changeTotalAnswersObject, totalAnswersObject, read } =
    useTemplateContext();

  return (
    <FlexCol key={question.ID} className="w-full">
      <Card>
        {/* <h3 className="mb-2.5 font-medium text-black whitespace-pre-line">{question.QuestionText}</h3> */}
        <div className={"mb-2.5 markdown-text whitespace-pre-line"}>
          <ReactMarkdown
            remarkPlugins={[remarkGfm, remarkBreaks]}
            rehypePlugins={[rehypeRaw, [rehypeSanitize, schema]]}
            // skipHtml={true}
          >
            {question.QuestionText}
          </ReactMarkdown>
        </div>
        <p className="mb-2.5">
          {question.QuestionType === "select" &&
            "Можно выбрать несколько вариантов ответа"}
          {question.QuestionType === "radio" && "Выберите 1 вариант ответа"}
        </p>
        <div className="space-y-2.5">
          {question.QuestionType === "select" && (
            <CheckBoxes
              read={read}
              question={question}
              initial={
                totalAnswersObject.answers
                  ? getSelectedMapByArray(
                      totalAnswersObject.answers[question.ID.toString()],
                      question.QuestionType,
                    )
                  : new Map()
              }
              getResult={(answers) =>
                changeTotalAnswersObject("answers", {
                  ...totalAnswersObject.answers,
                  [question.ID.toString()]: answers,
                })
              }
            />
          )}

          {question.QuestionType === "radio" && (
            <Radios
              read={read}
              question={question}
              initial={
                totalAnswersObject.answers &&
                totalAnswersObject.answers[question.ID.toString()]
                  ? totalAnswersObject.answers[question.ID.toString()]
                  : null
              }
              getResult={(answer) =>
                changeTotalAnswersObject("answers", {
                  ...totalAnswersObject.answers,
                  [question.ID.toString()]: answer,
                })
              }
            />
          )}

          {question.QuestionType === "rate" && (
            <Rates
              read={read}
              question={question}
              initial={
                totalAnswersObject.answers &&
                totalAnswersObject.answers[question.ID.toString()]
                  ? totalAnswersObject.answers[question.ID.toString()]
                  : 0
              }
              getResult={(answer) =>
                changeTotalAnswersObject("answers", {
                  ...totalAnswersObject.answers,
                  [question.ID.toString()]: answer,
                })
              }
            />
          )}
        </div>
      </Card>
    </FlexCol>
  );
}

export function Rates({
  className,
  read,
  initial = 0,
  question,
  title,
  getResult,
}: {
  className?: string;
  read?: boolean;
  initial?: number;
  question: QuestionType;
  title?: string;
  getResult: (answers: number) => void;
}) {
  function changeRate(n: number) {
    getResult(n);
  }

  return (
    <FlexRow className={twMerge("flex-wrap py-[5px]", className)}>
      <FlexCol className="w-full">
        {title && <p className="mb-2.5 font-medium text-black">{title}</p>}
      </FlexCol>
      <FlexCol className="w-full">
        <TGRates
          initial={initial}
          disable={read}
          onChange={changeRate}
          list={[1, 2, 3, 4, 5]}
        />
      </FlexCol>
    </FlexRow>
  );
}

type OptionType = {
  ID: number;
  Title: string;
  type: "radio" | "select" | "rate";
};

function CheckBoxes({
  read,
  initial = new Map(),
  question,
  getResult,
}: {
  read?: boolean;
  initial?: Map<number, OptionType>;
  question: QuestionType;
  getResult: (answers: OptionType[]) => void;
}) {
  const [selected, setSelected] = useState<Map<number, OptionType>>(initial);

  function changeSelected(option: { ID: number; Title: string }) {
    const updatedSelected = new Map(selected);

    if (updatedSelected.has(option.ID)) {
      updatedSelected.delete(option.ID);
    } else {
      updatedSelected.set(option.ID, {
        ...option,
        type: question.QuestionType,
      });
    }

    setSelected(updatedSelected);

    getResult([...updatedSelected.values()]);
  }

  if (!question.Options.length) return <Loading />;

  return (
    <>
      {question.Options.map((option) => (
        <TGCheckbox
          disabled={read}
          key={option.ID}
          checkboxClass={read ? "bg-[#DFE4EA]" : ""}
          isChecked={selected.has(option.ID)}
          onChange={() => changeSelected(option)}
        >
          {option.Title}
        </TGCheckbox>
      ))}
    </>
  );
}

function Radios({
  question,
  read,
  initial = null,
  getResult,
}: {
  question: QuestionType;
  read?: boolean;
  initial?: OptionType | null;
  getResult: (answer: OptionType) => void;
}) {
  const [selected, setSelected] = useState<OptionType | null>(initial);

  function chooseOption(option: OptionType) {
    setSelected(option);

    getRadioAnswer(option);
  }

  function getRadioAnswer(option: OptionType) {
    getResult(option);
  }

  if (!question.Options.length) return <Loading />;

  return (
    <>
      {question.Options.map((option) => (
        <TGRadio
          disable={read}
          key={option.ID}
          isChecked={selected && selected.ID === option.ID}
          onChange={() =>
            chooseOption({ ...option, type: question.QuestionType })
          }
        >
          {option.Title}
        </TGRadio>
      ))}
    </>
  );
}

export function TGRates({
  disable = false,
  onChange,
  initial = 0,
  list,
}: {
  disable?: boolean;
  initial: number;
  onChange: (n: number) => void;
  list: number[];
}) {
  const [active, setActive] = useState(initial);

  function changeRate(n: number) {
    setActive(n);
    onChange(n);
  }

  return (
    <div className="rate-section">
      {list.map((n) => (
        <button
          disabled={disable}
          className={twMerge(
            n === active ? "active" : "",
            disable ? "bg-[#E5E7EB]" : "",
          )}
          onClick={() => changeRate(n)}
        >
          {n}
        </button>
      ))}
    </div>
  );
}

export function Employee({
  title,
  initial,
  onResult,
  buttonElement = null,
  isMobileView = false,
  zIndex = 70,
}: {
  title: string;
  initial: PersonType | null;
  onResult: (emp: PersonType | null) => void;
  buttonElement?: JSX.Element | null;
  isMobileView?: boolean;
  zIndex?: number;
}) {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [query, setQuery] = useState("");
  const [externalUserEmail, setExternalUserEmail] = useState("");
  const [isExternalUser, setIsExternalUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState<PersonType | null>(
    initial,
  );
  const [employees, setEmployees] = useState<PersonType[]>([]);

  useEffect(() => {
    setSelectedPerson(initial);
  }, [initial]);

  useEffect(() => {
    if (!openDialog) return;

    // Headless UI после открытия модалки переводит фокус на пустой initialFocus-div
    // и удерживает его, из-за чего по полю поиска не ставится курсор.
    // Снимаем фокус с постороннего якоря до того, как отдать его полю поиска.
    const focusSearchInput = (input: HTMLElement) => {
      const active = document.activeElement as HTMLElement | null;
      if (active && active !== input) active.blur();
      input.focus();
    };

    // Панель модалки монтируется не сразу, поэтому пробуем несколько кадров.
    let raf = 0;
    let attempt = 0;
    const tryFocus = () => {
      const input = searchInputRef.current;
      if (input) {
        focusSearchInput(input);
        return;
      }
      attempt += 1;
      if (attempt < 12) {
        raf = requestAnimationFrame(tryFocus);
      }
    };
    raf = requestAnimationFrame(tryFocus);

    return () => cancelAnimationFrame(raf);
  }, [openDialog]);

  function toggleDialog(state: boolean) {
    setOpenDialog(state);
  }

  function handleSearch(value: string) {
    if (value !== query) {
      setQuery(value);
    }
  }

  function backButton() {
    setOpenDialog(false);
    onResult(initial);
  }

  function submitEmployee() {
    if (!selectedPerson) {
      return;
    }

    setOpenDialog(false);
    onResult(selectedPerson);

    setQuery("");
    setEmployees([]);
  }

  function resetQuery() {
    setSelectedPerson(null);
    setEmployees([]);
    setQuery("");
  }

  function toggleExternalUser(state: boolean) {
    if (state) {
      setExternalUserEmail("");
    } else {
      setQuery("");
    }

    setSelectedPerson(null);
    setEmployees([]);
    setIsExternalUser(state);
  }

  function handleExternalUserEmail(value: string) {
    if (value.length > 2) {
      const shortName = value[0].toUpperCase();

      const externalUser = {
        Email: value,
        Department: "",
        Position: "",
        Title: value,
        ID: 0,
        UserID: 0,
        Avatar: null,
        ShortName: shortName,
        externalUser: true,
      };
      setSelectedPerson(externalUser);
    }

    setExternalUserEmail(value);
  }

  useAsyncEffect(async () => {
    let results: PersonType[] = [];

    setLoading(true);

    try {
      if (query.length >= 3) {
        const users = (await searchPeopleRequest(
          query + "*",
        )) as unknown as SearchPeopleType[];

        results = users.reduce((acc: PersonType[], user: SearchPeopleType) => {
          const accountValue = user.AccountName
            ? removePrefix(user.AccountName, prefix)
            : "";
          const email =
            (user.WorkEmail && user.WorkEmail.includes("@") && user.WorkEmail) ||
            (accountValue && accountValue.includes("@") && accountValue) ||
            user.WorkEmail ||
            accountValue;

          const name =
            user.FirstName +
            " " +
            user.LastName +
            " (" +
            (user.UserName ||
              user.abiGlobalID ||
              user.apiGlobalID ||
              "Нет номера") +
            ")";

          const shortName = user.FirstName[0] + user.LastName[0];

          if (!name.toLowerCase().includes(query.toLowerCase())) {
            return acc;
          }

          acc.push({
            Email: email,
            Department: "",
            Position: "",
            Title: name,
            ID: user.DocId,
            UserID: user.DocId,
            Avatar: user.PictureURL,
            ShortName: shortName,
          });

          return acc;
        }, [] as PersonType[]);
      }

      setEmployees(results);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [query]);

  return (
    <FlexRow
      className={twMerge(
        "flex flex-nowrap justify-between items-center p-9 font-medium",
        isMobileView && "p-5",
      )}
    >
      <FlexCol className="grow min-w-0">
        {isMobileView ? (
          <FlexCol className="text-[16px] leading-[22px] min-h-7.5">
            <span className={twMerge(selectedPerson ? "text-black" : "")}>
              {title}:
            </span>
            {selectedPerson ? (
              <FlexRow className="mt-2 items-center gap-2.5 text-black min-w-0">
                <FlexCol className="shrink-0">
                  {selectedPerson.Avatar ? (
                    <img
                      className="w-7.5 h-7.5 rounded-full object-cover bg-darkblue"
                      src={selectedPerson.Avatar}
                      alt={selectedPerson.Title}
                    />
                  ) : (
                    <FlexCol className="font-medium text-white select-none text-[12px] max-sm:text-[10px] bg-darkblue flex items-center justify-center w-7.5 h-7.5 rounded-full">
                      {selectedPerson.ShortName.toUpperCase()}
                    </FlexCol>
                  )}
                </FlexCol>
                <FlexCol className="min-w-0 break-words text-black">
                  {selectedPerson.Title}
                </FlexCol>
              </FlexRow>
            ) : (
              <span className="mt-2 block text-[#637381]">
                сотрудник не выбран
              </span>
            )}
          </FlexCol>
        ) : (
          <FlexRow className="text-[18px] items-center space-x-2.5 min-h-7.5">
            <FlexCol className={twMerge(selectedPerson ? "text-black" : "")}>
              {title}:
            </FlexCol>
            {selectedPerson ? (
              <FlexCol>
                <FlexRow className="text-black space-x-2.5 justify-center">
                  <FlexCol>
                    {selectedPerson.Avatar ? (
                      <img
                        className="w-7.5 h-7.5 rounded-full object-cover bg-darkblue"
                        src={selectedPerson.Avatar}
                        alt={selectedPerson.Title}
                      />
                    ) : (
                      <FlexCol className="font-medium text-white select-none text-[12px] max-sm:text-[10px] bg-darkblue flex items-center justify-center w-7.5 h-7.5 rounded-full">
                        {selectedPerson.ShortName.toUpperCase()}
                      </FlexCol>
                    )}
                  </FlexCol>
                  <FlexCol>{selectedPerson.Title}</FlexCol>
                </FlexRow>
              </FlexCol>
            ) : (
              <FlexCol>сотрудник не выбран</FlexCol>
            )}
          </FlexRow>
        )}
      </FlexCol>
      <FlexCol className="shrink-0">
        {buttonElement ? (
          buttonElement
        ) : (
          <button onClick={() => toggleDialog(true)}>
            <SelectIcon isSelect={!!selectedPerson} />
          </button>
        )}
      </FlexCol>
      <Modal
        zIndex={zIndex}
        open={openDialog}
        toggleDialog={toggleDialog}
        modalClassName={twMerge(
          isMobileView && "!min-h-0 !w-[calc(100vw-24px)] !min-w-0 rounded-xl py-5",
        )}
      >
        <header
          className={twMerge(
            "flex justify-between items-center px-10 pb-4",
            isMobileView && "flex-col items-start gap-3 px-5 pb-2",
          )}
        >
          <h2>Выбор сотрудника</h2>
          <TGCheckbox
            isChecked={isExternalUser}
            onChange={() => toggleExternalUser(!isExternalUser)}
            checkboxClass="mr-1"
            labelClass={twMerge(
              isMobileView && "text-black text-[16px] leading-[22px] font-medium",
            )}
          >
            Внешний сотрудник
          </TGCheckbox>
        </header>

        <div className={twMerge("px-10 py-5 grow", isMobileView && "px-5 py-4")}>
          <FlexRow className="relative flex-wrap mb-5">
            {!isExternalUser ? (
              <>
                <div className="relative w-full hide-cancel-button">
                  <SearchUI
                    type="text"
                    ref={searchInputRef}
                    placeholder={selectedPerson ? "" : "Введите имя сотрудника"}
                    defaultValue={selectedPerson ? selectedPerson.Title : query}
                    onClick={handleSearch}
                    loading={loading}
                    label={"ФИО"}
                    // disabled={!!selectedPerson}
                    resetButton={!!selectedPerson}
                    inputClass={twMerge(
                      "appearance-none",
                      selectedPerson ? "text-white placeholder:text-white" : "",
                    )}
                    resetHandle={() => resetQuery()}
                  />
                  {selectedPerson && (
                    <div
                      className={twMerge(
                        "absolute bottom-0 left-0 flex items-center gap-2.5 bg-transparent px-5 pt-[1.35rem] pb-[0.25rem] text-black pointer-events-none pr-10",
                      )}
                    >
                      <FlexCol className="shrink-0">
                        {selectedPerson.Avatar ? (
                          <img
                            className={"w-7.5 h-7.5 rounded-full object-cover"}
                            src={`${selectedPerson.Avatar}`}
                            alt={selectedPerson.Title}
                          />
                        ) : (
                          <FlexCol
                            className={twMerge(
                              "font-medium text-white select-none text-[12px] max-sm:text-[10px] bg-darkblue flex items-center justify-center w-7.5 h-7.5 rounded-full",
                            )}
                          >
                            {selectedPerson.ShortName.toUpperCase()}
                          </FlexCol>
                        )}
                      </FlexCol>
                      <FlexCol className="min-w-0 grow break-words whitespace-normal pr-8 leading-[22px]">
                        {selectedPerson.Title}
                      </FlexCol>
                    </div>
                  )}
                </div>
                {!selectedPerson && employees.length > 0 && (
                  <div className="absolute max-h-64 h-auto  overflow-y-auto rounded-md shadow-custom mt-2.5 bg-white top-[calc(100%+10px)] w-full py-2.5 text-[14px] scrollbar-thin scrollbar-w-2 scrollbar-thumb-rounded-lg scrollbar-thumb-[#D1D5DB]">
                    {employees.map((e) => (
                      <div
                        key={e.ID}
                        className={twMerge(
                          selectedPerson &&
                            e.ID === (selectedPerson as PersonType)?.ID
                            ? "bg-[#F3F4F6]"
                            : "",
                          "flex px-5 py-2 space-x-2.5 cursor-pointer items-center hover:bg-[#F3F4F6] text-black",
                        )}
                        onClick={() => {
                          setSelectedPerson(e);
                        }}
                      >
                        <FlexCol>
                          <UserAvatar
                            avatar={e.Avatar}
                            displayName={e.Title}
                            email={e.Email}
                            shortName={e.ShortName}
                          />
                        </FlexCol>
                        <FlexCol>{e.Title}</FlexCol>
                      </div>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <SearchUI
                type="text"
                ref={searchInputRef}
                placeholder={"Введите имя сотрудника"}
                defaultValue={externalUserEmail}
                onClick={handleExternalUserEmail}
                loading={loading}
                label={"ФИО"}
                search={false}
                inputClass={twMerge("appearance-none")}
              />
            )}
          </FlexRow>
        </div>

        <footer
          className={twMerge(
            "flex justify-between px-10 pt-10 mt-4 border-t",
            isMobileView && "mt-2 flex-col gap-3 px-5 pt-4",
          )}
        >
          <TGButton
            color="bluedark"
            onClick={submitEmployee}
            disabled={!selectedPerson}
            className={twMerge(
              isMobileView && "h-[44px] w-full justify-center text-[14px]",
            )}
          >
            Сохранить
          </TGButton>
          <TGButton
            onClick={backButton}
            className={twMerge(
              isMobileView && "h-[44px] w-full justify-center text-[14px]",
            )}
          >
            Отмена
          </TGButton>
        </footer>
      </Modal>
    </FlexRow>
  );
}

export function TableHeaderColumn({
  tableHeaderContent,
  sortDirection,
  onClick,
}: TableHeaderColumnProps) {
  return (
    <FlexCol className="select-none" style={tableHeaderContent.style}>
      <FlexRow className="gap-x-2 items-center">
        {tableHeaderContent.icon && (
          <FlexCol>{tableHeaderContent.icon}</FlexCol>
        )}
        <FlexCol className="font-medium whitespace-pre-line w-fit">
          {tableHeaderContent.title}
        </FlexCol>
        {tableHeaderContent.sort && (
          <FlexCol className="w-auto cursor-pointer" onClick={onClick}>
            <SortIcon sortDirection={sortDirection} />
          </FlexCol>
        )}
      </FlexRow>
    </FlexCol>
  );
}

const criticalItemStyle = cva("block h-2 w-2 rounded-full", {
  variants: {
    active: {
      true: "bg-[#BA0C2F]",
      false: "bg-[#8899A8]",
    },
  },
  defaultVariants: {
    active: false,
  },
});

export function CriticallyListItem({ item }: { item: boolean }) {
  return (
    <FlexRow className="items-center space-x-1">
      <FlexCol>
        <span className={twMerge(criticalItemStyle({ active: item }))}></span>
      </FlexCol>
      <FlexCol>{item ? "" : "Не "}Критичный</FlexCol>
    </FlexRow>
  );
}

export const GetNotificationDrawerMobile = GetNotificationDrawer;
